import { ICalendarDate } from '../Calendar';
import { ICalendarViewState } from '../View/CalendarView';
const todayJS = new Date();
export const today = {
  year: todayJS.getFullYear(),
  monthIndex: todayJS.getMonth(),
  day: todayJS.getDate()
};
export function calcDaysOfSelectedMonthInFirstWeek(weekdayIndex) {
  let result;
  if (weekdayIndex === 0) {
    result = 1;
  } else {
    result = 8 - weekdayIndex;
  }
  return result;
}
export function calcDaysOfSelectedMonthInLastWeek(daysInMonth, daysInFirstWeek) {
  return (daysInMonth - daysInFirstWeek) % 7;
}
export function calcDaysOfPrevMonthInFirstWeek(weekdayIndex) {
  let result;
  if (weekdayIndex === 0) {
    result = 6;
  } else {
    result = weekdayIndex - 1;
  }
  return result;
}
export function calcDaysOfNextMonthInLastWeek(daysInMonth, daysInFirstWeek) {
  let result;
  if ((daysInMonth - daysInFirstWeek) % 7 === 0) {
    result = 0;
  } else {
    result = 7 - (daysInMonth - daysInFirstWeek) % 7;
  }
  return result;
}
export function calcMondayDateOfPrevMonthInCurrentView(daysInPrevMonth, daysOfPrevMonthInFirstWeek) {
  return daysInPrevMonth - daysOfPrevMonthInFirstWeek;
}
export function getDaysInMonth({
  year,
  monthIndex
}) {
  return new Date(year, monthIndex + 1, 0).getDate();
}
export function calcYearAndMonth({
  year,
  monthIndex,
  changeMonths
}) {
  let result;
  if (monthIndex + changeMonths < 0) {
    const subYears = Math.ceil(Math.abs(changeMonths + monthIndex) / 12);
    const resultMonthIndex = 11 - Math.abs(monthIndex - changeMonths - 1) % 12;
    result = {
      year: year - subYears,
      monthIndex: resultMonthIndex
    };
  } else if (monthIndex + changeMonths > 11) {
    const addYears = Math.floor((monthIndex + changeMonths) / 12);
    const resultMonthIndex = (monthIndex + changeMonths) % 12;
    result = {
      year: year + addYears,
      monthIndex: resultMonthIndex
    };
  } else {
    result = {
      year: year,
      monthIndex: monthIndex + changeMonths
    };
  }
  return result;
}
export function isDateExists(date) {
  const jsDate = new Date(date.year, date.monthIndex, date.day);
  return jsDate.getDate() === date.day && jsDate.getMonth() === date.monthIndex && jsDate.getFullYear() === date.year;
}
export function incrementDateByMonths(date, incrementBy) {
  let result;
  if (date.monthIndex + incrementBy > 11) {
    const addYears = Math.floor((date.monthIndex + incrementBy) / 12);
    const resultMonthIndex = (date.monthIndex + incrementBy) % 12;
    result = {
      year: date.year + addYears,
      monthIndex: resultMonthIndex,
      day: date.day
    };
  } else {
    result = {
      year: date.year,
      monthIndex: date.monthIndex + incrementBy,
      day: date.day
    };
  }
  !isDateExists(result) && (result = {
    ...result,
    day: getDaysInMonth({
      year: result.year,
      monthIndex: result.monthIndex
    })
  });
  return result;
}
export function decrementDateByMonths(date, decrementBy) {
  let result;
  if (date.monthIndex - decrementBy < 0) {
    const subYears = Math.ceil((decrementBy - date.monthIndex) / 12);
    const resultMonthIndex = 11 - (decrementBy - date.monthIndex - 1) % 12;
    result = {
      year: date.year - subYears,
      monthIndex: resultMonthIndex,
      day: date.day
    };
  } else {
    result = {
      year: date.year,
      monthIndex: date.monthIndex - decrementBy,
      day: date.day
    };
  }
  !isDateExists(result) && (result = {
    ...result,
    day: getDaysInMonth({
      year: result.year,
      monthIndex: result.monthIndex
    })
  });
  return result;
}
export function incrementDateByDays(date, incrementBy) {
  const jsDate = new Date(date.year, date.monthIndex, date.day);
  jsDate.setDate(jsDate.getDate() + incrementBy);
  return {
    year: jsDate.getFullYear(),
    monthIndex: jsDate.getMonth(),
    day: jsDate.getDate()
  };
}
export const tomorrow = incrementDateByDays(today, 1);
export function decrementDateByDays(date, decrementBy) {
  const jsDate = new Date(date.year, date.monthIndex, date.day);
  jsDate.setDate(jsDate.getDate() - decrementBy);
  return {
    year: jsDate.getFullYear(),
    monthIndex: jsDate.getMonth(),
    day: jsDate.getDate()
  };
}
export const isLeapYear = year => {
  return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
};
export function isDateBGreaterThanDateA(a, b) {
  return a.year === b.year && a.monthIndex === b.monthIndex && a.day < b.day || a.year === b.year && a.monthIndex < b.monthIndex || a.year < b.year;
}
export function isTwoDatesEqual(a, b) {
  return a.year === b.year && a.monthIndex === b.monthIndex && a.day === b.day;
}
export function isTwoViewsEqual(a, b) {
  return a.year === b.year && a.monthIndex === b.monthIndex;
}
export function generateCalendarViewData({
  year,
  monthIndex
}) {
  const daysInCurrentViewMonth = getDaysInMonth({
    year,
    monthIndex
  });
  const daysInPreviousViewMonth = getDaysInMonth(calcYearAndMonth({
    year,
    monthIndex,
    changeMonths: -1
  }));
  const firstWeekdayOfCurrentViewMonth = new Date(year, monthIndex, 1).getDay();
  const daysOfMonthInFirstWeek = calcDaysOfSelectedMonthInFirstWeek(firstWeekdayOfCurrentViewMonth);
  const daysOfMonthInLastWeek = calcDaysOfSelectedMonthInLastWeek(daysInCurrentViewMonth, daysOfMonthInFirstWeek);
  return {
    daysInCurrentViewMonth,
    daysInPreviousViewMonth,
    firstWeekdayOfCurrentViewMonth,
    daysOfMonthInFirstWeek,
    daysOfMonthInLastWeek
  };
}